import React, { useRef } from 'react'
import { result } from 'libraries/lodash'
import { pushUrl } from 'front-end-core/core/history'
import FilterBox from 'pages/comments/FilterBox'

const Filter = ({
  multi,
  link,
  title,
  visibleTo,
  options,
  shortcuts,
  value: currentValue,
  multiSuffix,
  userIs,
  expanded,
  setExpanded
}) => {
  const valueRef = useRef()
  const shortcutsRef = useRef()
  const dropdownRef = useRef()

  const onChange = (event, isButtonEvent) => {
    if (!multi || isButtonEvent) {
      setExpanded(false)
    }
    const url = link(event.currentTarget.value)
    pushUrl(url)
  }

  const isValidValue = value => !!(options.concat(shortcuts || []).filter(option => option.value === value).length)
  const findNameFor = (value) => result(options.concat(shortcuts || []).filter(option => option.value === value), [0, 'name'], null)
  const isShortcut = value => !!((shortcuts || []).filter(option => option.value === value).length)
  const currentValueList = currentValue.split(',').filter(isValidValue)

  return visibleTo && !(visibleTo.filter(val => userIs(val)).length)
    ? null
    : (
      <div className=''>
        <div className='w-100 flex justify-center'>
          <span>
            {title}
          </span>
        </div>
        <FilterBox
          {...{
            valueRef,
            expanded,
            setExpanded,
            multi,
            currentValueList,
            options,
            isShortcut,
            findNameFor,
            multiSuffix,
            shortcuts,
            title,
            shortcutsRef,
            dropdownRef,
            onChange
          }}
        />
      </div>
      )
}

export default Filter
